import {distance} from 'ol/coordinate';
import Polyline from 'ol/format/Polyline.js';


/**
 *
 * @param {string} encoded points
 * @param {boolean} is3D
 * @param {string} mapProjection
 * @return {import ('ol/geom/LineString').default}
 */
export function parseGraphhopperPoints(points, is3D, mapProjection) {
  const format = new Polyline({
    factor: 1e5,
    geometryLayout: is3D ? 'XYZ' : 'XY'
  });

  const route = /** @type {import ('ol/geom/LineString').default} */ (
    format.readGeometry(points, {
      dataProjection: 'EPSG:4326',
      featureProjection: mapProjection
    })
  );
  if (is3D) {
    // Fix elevation by dividing
    const coordinates = route.getCoordinates();
    for (let i = 0; i < coordinates.length; ++i) {
      coordinates[i][2] *= 10000 / 10;
    }
    route.setCoordinates(coordinates, 'XYZ');
  }
  return route;
}


/**
 *
 * @param {import('ol/coordinate').Coordinate[]} coordinates
 * @param {import ('ol/geom/LineString').default} linestring
 * @return {number[]} ratio of the distance to the viapoint / total track length
 */
export function measurePointsAlongLineString(coordinates, linestring, tolerance) {
  const distances = [];
  if (coordinates.length === 0) {
    return distances;
  }
  const lc = linestring.getCoordinates();
  let dist = 0;
  const points = coordinates.slice(1, -1);
  for (let idx = 0; idx < lc.length; ++idx) {
    const vertex = lc[idx];
    dist += idx === 0 ? 0 : distance(vertex, lc[idx - 1]);
    if (points.length > 0) {
      const delta = distance(vertex, points[0]);
      if (delta < tolerance) {
        // found
        points.shift(); // remove the element
        distances.push(dist);
      }
    }
  }
  // the ends are hardcoded because we want to ensure they really are the first and last coordinates
  // of the linestring; and they are mandatory.
  distances.unshift(0);
  distances.push(dist);
  if (coordinates.length !== distances.length) {
    console.error('measurePoints mismatch', coordinates, linestring, dist, distances);
  }
  return distances.map(d => d / dist);
}

/**
 *
 * @param {number[]} ratios
 * @param {import ('ol/geom/LineString').default} linestring
 * @return {number[]}
 */
export function snapCoordinatesToLineString(ratios, linestring, tolerance) {
  const length = linestring.getLength();
  let dist = 0;
  ratios = ratios.slice();
  const lc = linestring.getCoordinates();
  const indices = [];
  for (let idx = 0; idx < lc.length; ++idx) {
    const vertex = lc[idx];
    const incr = idx === 0 ? 0 : distance(vertex, lc[idx - 1]);
    const searchedRatio = ratios[0];
    const searchedDist = searchedRatio * length;
    const distToPreviousPoint = searchedDist - dist;
    const distToNext = dist + incr - searchedDist;
    if (distToPreviousPoint >= -tolerance && distToNext >= -tolerance) {
      // found it
      if (distToNext > distToPreviousPoint) {
        // closer to the previous point
        indices.push(idx - 1);
      } else {
        // closer to the current point
        indices.push(idx);
      }
      ratios.shift();
      if (ratios.length === 0) {
        break;
      }
    }
    dist += incr;
  }
  return indices;
}
